/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Code from 'components/Code';
import Table, {Row, Column} from 'components/Table';
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    code: "code",
    p: "p",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h3, {
      children: [_jsx(_components.code, {
        children: "TaggedTemplateLiteral"
      }), "(", _jsx(_components.code, {
        children: "TaggedTemplateLiteral"
      }), ")"]
    }), "\n", _jsxs(_components.p, {
      children: ["这就是你传递到样式调用中的内容 - 标记的模板字面量。这是 ES6 语言的特性。你可以在 ", _jsx(_components.a, {
        href: "/docs/advanced#tagged-template-literals",
        children: "标记模板字面量"
      }), " 部分了解有关它们的更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This is what you pass into your styled calls – a tagged template literal.\nThis is an ES6 language feature. You can learn more about them in the\n", _jsx(_components.a, {
        href: "/docs/advanced#tagged-template-literals",
        children: "Tagged Template Literals"
      }), " section."]
    }), "\n", _jsxs(Table, {
      head: ['Inputs', 'Description'],
      children: [_jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "Rule"
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "Any CSS rules (string)"
          })
        })]
      }), _jsxs(Row, {
        children: [_jsx(Column, {
          children: _jsx(Code, {
            children: "Interpolation"
          })
        }), _jsx(Column, {
          children: _jsx(_components.p, {
            children: "This can either be a string or a function. Strings are combined with the\nrules as-is. Functions will receive the styled component's props as the\nfirst and only argument."
          })
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["阅读 ", _jsx(_components.a, {
        href: "/docs/basics#adapting-based-on-props",
        children: "根据属性进行调整"
      }), " 部分中有关如何根据属性调整样式的更多信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Read more about how to adapt styling based on props in the\n", _jsx(_components.a, {
        href: "/docs/basics#adapting-based-on-props",
        children: "Adapting based on props"
      }), " section."]
    }), "\n", _jsxs(_components.p, {
      children: ["传递到插值函数的属性会附加一个特殊属性 ", _jsx(_components.code, {
        children: "theme"
      }), "，该属性由更高级别的 ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), " 组件注入。有关详细信息，请查看 ", _jsx(_components.a, {
        href: "/docs/advanced#theming",
        children: "主题化"
      }), " 部分。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The properties that are passed into an interpolated function get attached a special\nproperty, ", _jsx(_components.code, {
        children: "theme"
      }), ", which is injected by a higher level ", _jsx(_components.code, {
        children: "ThemeProvider"
      }), " component.\nCheck the section on ", _jsx(_components.a, {
        href: "/docs/advanced#theming",
        children: "Theming"
      }), " for more information on this."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// import styled from 'styled-components'\n\nconst padding = '3em'\n\nconst Section = styled.section<{ $background?: string; }>`\n  color: white;\n\n  /* Pass variables as inputs */\n  padding: ${padding};\n\n  /* Adjust the background from the properties */\n  background: ${props => props.$background};\n`\n\nrender(\n  <Section $background=\"royalblue\">\n    ✨ Magic\n  </Section>\n)\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "你还可以直接从插值或输入对象返回对象，它们将被视为内联样式。然而，强烈建议不要这样做，因为 CSS 语法支持伪选择器、媒体查询、嵌套等，而对象语法则不支持。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can also return objects from interpolations or input objects directly, and they'll be\ntreated as inline styles. However this is highly discouraged, as the CSS syntax has support\nfor pseudo selectors, media queries, nesting, etc., which the object syntax doesn't."
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
